import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { BehaviorSubject, map, Observable } from "rxjs";
import {
  GblEnvResModel,
  GeneralResModel,
  OrgTypeWiseSiteModel,
} from "src/app/_models";
import { SiteInformation } from "src/app/_models/site-information.model";
import { User } from "src/app/_models/user-models/user";
import { environment } from "src/environments/environment";
import { ApiService } from "../api/api.service";

@Injectable({
  providedIn: "root",
})
export class SiteService {
  photoUrl = new BehaviorSubject<string>("");
  private apiPATH = "Site/";
  private url: string;

  private baseURL = `${environment.apiUrl}Site/`;
  private siteOrderIdSubject = new BehaviorSubject<number>(0);
  data$ = this.siteOrderIdSubject.asObservable();

  client: User = new User();

  constructor(
    private router: Router,
    private api: ApiService,
    private _httpClient: HttpClient,
  ) {}

  // getOrgTypeWiseList(orgId: number) {
  //   return this._httpClient.get<GeneralResModel<OrgTypeWiseSiteModel>>(
  //     `${this.baseURL}GetOrgTypeWiseList/${orgId}`
  //   );
  // }

  getOrgTypeWiseList(orgId: number) {
    this.client = null;
    this.client = JSON.parse(localStorage.getItem("user"));

    return this._httpClient
      .get<
        GeneralResModel<OrgTypeWiseSiteModel>
      >(`${this.baseURL}GetOrgTypeWiseList/${orgId}`)
      .pipe(
        map((response: GeneralResModel<OrgTypeWiseSiteModel>) => {
          if (
            (this.client.OrgType === "SP" ||
              this.client.OrgType === "Group" ||
              this.client.OrgType === "Customer") &&
            response?.Result.SiteList?.length
          ) {
            response.Result.SiteList.forEach((org) => {
              org.OrgName = `${org.OrgName} (${org.OrgId})`;
            });
          }
          return response;
        }),
      );
  }

  getSiteByOrgTypeId(OrgTypeId: number, RequesterOrgTypeId: number) {
    return this._httpClient.get<SiteInformation[]>(
      `${this.baseURL}getSiteByOrgTypeId/${OrgTypeId}/${RequesterOrgTypeId}`,
    );
  }

  getCustometHospitalList() {
    return this._httpClient.get<SiteInformation[]>(
      `${this.baseURL}getCustometHospitalList`,
    );
  }

  getFilterHospitalList(type: string) {
    return this._httpClient.get<GeneralResModel<SiteInformation[]>>(
      `${this.baseURL}GetFilterHospitalList/${type}`,
    );
  }

  getHospitalListByOrgId(orgid: any, type: string) {
    return this._httpClient.get<GeneralResModel<SiteInformation[]>>(
      `${this.baseURL}GetHospitalListByOrgId/${orgid}/${type}`,
    );
  }

  getHospitalListByIdAuthorize() {
    return this.api
      .get<SiteInformation[]>(`${this.apiPATH}getHospitalListByIdAuthorize`)
      .pipe(
        map((response: SiteInformation[]) => {
          response.forEach((org: SiteInformation) => {
            org.OrgName = `${org.OrgName} (${org.OrgId})`;
          });
          return response;
        }),
      );
  }

  getHospitalList() {
    this.client = null;
    this.client = JSON.parse(localStorage.getItem("user"));

    return this.api
      .get<SiteInformation[]>(`${this.apiPATH}getHospitalList`)
      .pipe(
        map((response: SiteInformation[]) => {
          if (this.client.OrgType === "SP") {
            response.forEach((org: SiteInformation) => {
              org.OrgName = `${org.OrgName} (${org.OrgId})`;
            });
          }
          return response;
        }),
      );
  }

  setOrgId(orgId: number): void {
    this.siteOrderIdSubject.next(orgId);
  }

  getHospitalListbyCustomerId() {
    return this.api.get<SiteInformation[]>(
      `${this.apiPATH}getHospitalListById`,
    );
  }

  getSiteInfos() {
    return this.api.get<SiteInformation[]>(`${this.apiPATH}getSiteInfos`);
  }

  approveSite(siteInfo: SiteInformation) {
    return this.api.post<boolean>(`${this.apiPATH}approveSite`, siteInfo);
  }

  denySite(siteInfo: SiteInformation) {
    return this.api.post<boolean>(`${this.apiPATH}denySite`, siteInfo);
  }
  insertSiteInformation(site: SiteInformation) {
    return this.api.post<boolean>(`${this.apiPATH}insertSiteInformation`, site);
  }
  getUniqueSuffix() {
    let response = this.api.get<string>(`${this.apiPATH}getUniqueOrgSuffix`);
    return response;
  }

  getUniquePrefix(orgName) {
    let response = this.api.get<string>(
      `${this.apiPATH}getUniqueOrgPrefix/${orgName}`,
    );
    return response;
  }

  isExistEmail(email: string): Observable<boolean> {
    return this.api.get<boolean>(`${this.apiPATH}isExistingSiteEmail/${email}`);
  }

  getSiteDetail(orgId: number) {
    return this.api.get<SiteInformation>(
      `${this.apiPATH}getSiteDetail/${orgId}`,
    );
  }

  getHospitalByOrgGroupId(orgGroupId: number) {
    return this.api.get<SiteInformation[]>(
      `${this.apiPATH}GetHospitalByOrgGroupId/${orgGroupId}`,
    );
  }

  getGblEnv(orgId: number) {
    return this.api.get<GblEnvResModel>(
      `${this.apiPATH}getSiteDetail/${orgId}`,
    );
  }

  updateSitePacsEndPoint(orgId: number, endPoint: string) {
    return this.api.put<SiteInformation>(
      `${this.apiPATH}updateSitePacsEndPoint/${orgId}/${endPoint}`,
      SiteInformation,
    );
  }
  updateSiteDetails(site: SiteInformation) {
    return this.api.put<SiteInformation>(
      `${this.apiPATH}updateSiteDetails`,
      site,
    );
  }

  emailAlreayExists(email: string) {
    return this.api.get<GeneralResModel<boolean>>(
      `${this.apiPATH}emailAlreayExists/${email}`,
    );
  }

  addNewHospital(org: FormData) {
    // return this.api.post<User>(`${this.apiPATH}addNewRadiologist`, user );

    return this._httpClient.post<GeneralResModel<boolean>>(
      `${this.baseURL}addNewHospital`,
      org,
      {
        responseType: "json",
      },
    );
  }
}
